import React from 'react';
import { useParams } from 'react-router-dom';
import { Row, Col, Container } from 'react-bootstrap';
import styles from './ErrorPage.module.scss';

type ErrorInfo = {
  title: string;
  message: string;
};

const errorMessages: Record<number, ErrorInfo> = {
  400: {
    title: 'Requisição Inválida',
    message: 'O servidor não conseguiu entender a requisição.',
  },
  401: {
    title: 'Não Autorizado',
    message: 'Você precisa fazer login para acessar esta página.',
  },
  403: {
    title: 'Proibido',
    message: 'Você não tem permissão para acessar este recurso.',
  },
  404: {
    title: 'Página Não Encontrada',
    message: 'A página que você está procurando não existe.',
  },
  500: {
    title: 'Erro Interno do Servidor',
    message: 'O servidor encontrou uma situação inesperada que impediu a conclusão da requisição.',
  },
  503: {
    title: 'Serviço Indisponível',
    message: 'O servidor está temporariamente indisponível.',
  },
};

type ErrorPageProps = {
  code?: number;
};

const ErrorPage: React.FC<ErrorPageProps> = ({ code }) => {
  const params = useParams<{ code?: string }>();
  const finalCode = code ?? Number(params.code);
  const error = errorMessages[finalCode] || {
    title: 'Erro Interno do Servidor',
    message: 'Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.',
  };

  return (
    <Container>
      <Row className={[styles['data-content'], styles['container'], "align-items-center", styles['error-page-message']].join(' ')} id="error-page-message">
        <Col md="12" className="text-content center text-center py-5">
          <h1>Erro {finalCode || '500'}</h1>
          <h4>{error.title}</h4>
          <p>{error.message}</p>
        </Col>
      </Row>
    </Container>
  );
};

export default ErrorPage;
